module.exports = __webpack_public_path__ + "assets/img/title-a9c618aa.png";